export default "__VITE_ASSET__COx_g0m0__"